// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ac968d7f","425":"bb62bfcf","602":"cbcc2eb2","609":"ee945c65","654":"c802b3c4","766":"25a12c2b","778":"f2863718","823":"4885150e","879":"5607c669","938":"ff97fc94","979":"4acf76bd"}[chunkId] + ".chunk.js";
};